var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btn_cls,on:{"click":function($event){return _vm.btnClick()}}},[_vm._v(_vm._s(_vm.btn_txt))])}
var staticRenderFns = []

export { render, staticRenderFns }